import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Template() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const getMatchingTemplate = async (
    affiliate,
    timestamp,
    data_source,
    matchOrder
  ) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      timestamp,
      data_source,
      matchOrder,
    });

    return apiCall({
      url: `${backendUrl}/api/event/template?${queryString}`,
      method: "GET",
      headers,
    });
  };

  const saveTemplate = async (affiliate, name, use, data_source, template) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      name,
      use,
      data_source,
    });

    return apiCall({
      url: `${backendUrl}/api/template?${queryString}`,
      method: "POST",
      headers,
      data: template,
    });
  };

  const applyTemplate = async (affiliate, data) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
    });

    return apiCall({
      url: `${backendUrl}/api/event/process?${queryString}`,
      method: "POST",
      headers,
      data,
    });
  };

  const getTemplateHeaders = async (affiliate, templateType) => {
    const { headers } = await queryParamsAndHeaders({
      affiliate,
    });
    const response = await apiCall({
      url: `${backendUrl}/api/event/template_columns`,
      method: "GET",
      headers,
    });
    if (!response.error) {
      if (Object.hasOwn(response.data, templateType)) {
        return response.data[templateType][0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return {
    getMatchingTemplate,
    saveTemplate,
    applyTemplate,
    getTemplateHeaders,
  };
}
